import { render, staticRenderFns } from "./popupShow.vue?vue&type=template&id=74547b10&scoped=true&"
import script from "./popupShow.vue?vue&type=script&lang=js&"
export * from "./popupShow.vue?vue&type=script&lang=js&"
import style0 from "./popupShow.vue?vue&type=style&index=0&id=74547b10&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74547b10",
  null
  
)

export default component.exports